import React, { Component } from 'react';
import format from 'date-fns/format';
import { player_info } from '~/tools/mll/headers';
import SocialHandle from '~/components/SocialHandles';
import './PlayerHeader.css';

class PlayerHeader extends Component {
	render() {		
	  const { 
			firstName, 
			lastName, 
			imageGist, 
			number, 
			instagramUrl,
			twitterUrl, 
			facebookUrl, 
			website 
		} = this.props.data;

		return (
			<div className='player-container'>
				<div className='player-banner'>
					<div className='player-info'>
						<div className='player-team-logo'>
							<img src={imageGist._1x1} alt='team logo'/>
						</div>
						<div className='player-number site-color'>{number}</div>
						<div className='player-fullname'>
							<span>{firstName}</span>
							<span>{lastName}</span>
						</div>
					</div>
					<div className='player-wrapper'>
						<div className='player-avatar'>
							<img src={imageGist._3x4 || require('~/assets/images/default_mll.jpg')} alt='avatar'/>
						</div>
						<div className='player-details'>
							<div className='personal-info'>
								{player_info[0].map((item, i) => (
									<div key={i}>
										<span className='details-header'>{item}</span>	
										<span className='details-info'>
											{	this.props.data[player_info[1][i]] !== null ? 
												( player_info[1][i] === 'dob'?  
													format(new Date(this.props.data[player_info[1][i]].replace('UTC', '')), 'MM/DD/YY') : 
													this.props.data[player_info[1][i]] )
												: 'N/A'
											}
										</span>
									</div>
								))}
							</div>
							<div className='social-handles'>
								<SocialHandle url={twitterUrl} icon={"ion-social-twitter"}/>
								<SocialHandle url={facebookUrl} icon={"ion-social-facebook"}/>
								<SocialHandle url={instagramUrl} icon={"ion-social-instagram"}/>
								<SocialHandle url={website} icon={"ion-ios-world-outline"}/>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default PlayerHeader;